import React, { useEffect, useState } from 'react';
import {
  getAllEmailTemplates,
  deleteEmailTemplate,
} from '../services/TemplatesService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TemplateSidebar from './TemplateSidebar';

function Templates() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [templateToDelete, setTemplateToDelete] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTemplate, setPreviewTemplate] = useState(null);

  useEffect(() => {
    fetchTemplates();
  }, []);

  async function fetchTemplates() {
    setLoading(true);
    setError(null);
    try {
      const data = await getAllEmailTemplates();
      setTemplates(data);
    } catch (err) {
      setError('Failed to load templates');
    }
    setLoading(false);
  }

  function handleEdit(template) {
    setEditingTemplate(template);
    setSidebarOpen(true);
  }

  function handleCreate() {
    setEditingTemplate(null);
    setSidebarOpen(true);
  }

  function handleDelete(template) {
    setTemplateToDelete(template);
    setShowDeleteModal(true);
  }

  async function confirmDelete() {
    try {
      await deleteEmailTemplate(templateToDelete.id);
      toast.success('Template deleted');
      setShowDeleteModal(false);
      setTemplateToDelete(null);
      fetchTemplates();
    } catch (err) {
      toast.error('Failed to delete template');
    }
  }

  return (
    <div className="mt-4" style={{ paddingLeft: 25, paddingRight: 25, width: '100%' }}>
      <ToastContainer />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Email Templates</h4>
        <button className="btn btn-primary" onClick={handleCreate}>
          + Create Template
        </button>
      </div>
      {loading ? (
        <div>Loading templates...</div>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : (
        <div className="table-responsive">
          <table className="table align-middle">
            <thead>
              <tr>
                <th>Name</th>
                <th>Subject</th>
                <th>Created</th>
                <th>Updated</th>
                <th style={{ width: 160 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {templates.length === 0 ? (
                <tr><td colSpan={5} className="text-center">No templates found.</td></tr>
              ) : (
                templates.map(t => (
                  <tr key={t.id}>
                    <td>{t.templateName}</td>
                    <td>{t.subject}</td>
                    <td>{t.createdAt ? new Date(t.createdAt).toLocaleString() : ''}</td>
                    <td>{t.updatedAt ? new Date(t.updatedAt).toLocaleString() : ''}</td>
                    <td>
                      <div className="btn-group">
                        <button className="btn btn-sm btn-outline-primary me-2" onClick={() => handleEdit(t)} title="Edit">
                          <i className="bi bi-pencil"></i>
                        </button>
                        <button className="btn btn-sm btn-outline-primary me-2" onClick={() => { setPreviewTemplate(t); setPreviewOpen(true); }} title="Preview">
                          <i className="bi bi-eye"></i>
                        </button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(t)} title="Delete">
                          <i className="bi bi-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
      {/* Sidebar for create/edit */}
      {sidebarOpen && (
        <TemplateSidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          template={editingTemplate}
          onSaved={() => {
            setSidebarOpen(false);
            fetchTemplates();
          }}
        />
      )}
      {/* Delete confirmation modal */}
      {showDeleteModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                Are you sure you want to delete template <strong>{templateToDelete?.templateName}</strong>?
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                <button className="btn btn-danger" onClick={confirmDelete}>Delete</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Preview Modal */}
      {previewOpen && previewTemplate && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Template Preview</h5>
                <button type="button" className="btn-close" onClick={() => setPreviewOpen(false)}></button>
              </div>
              <div className="modal-body">
                <h6>Name: {previewTemplate.templateName}</h6>
                <h6>Subject: {previewTemplate.subject}</h6>
                <div className="border p-3" style={{ minHeight: 100 }}>
                  <div dangerouslySetInnerHTML={{ __html: previewTemplate.body }} />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setPreviewOpen(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}



export default Templates; 